import React, { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchRetailer, fetchRangeSearch } from "../actions";
import { Grid, Segment } from "semantic-ui-react";
import ListMenu from "../banner/list-menu";
import SearchRangeForm from "./search";
import RangeResults from "./results";

const RangeChecker = () => {
  const {retailer} = useParams();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user);

  const [restricted, setRestricted] = useState(false);

  useEffect(() => {
    if (user.restrictByRetailer && user.retailer !== retailer) {
      setRestricted(true);
    }
  }, [user, retailer]);

  useEffect(() => {
    dispatch(fetchRetailer(retailer));
    return () => {
      dispatch(fetchRetailer(null));
      dispatch(fetchRangeSearch(null));
    };
  }, [retailer, dispatch]);

  if (restricted) return <Navigate to="/" />;

  return (
    <Grid padded>
      <Grid.Column width={16}>
        <ListMenu includeSearch={false} />
        <Segment attached="bottom">
          <SearchRangeForm />
          <RangeResults />
        </Segment>
      </Grid.Column>
    </Grid>
  );
};

export default RangeChecker;
